import { TRESPONSE_FACTORY_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const FACTORY_LIST_TABLE_MODEL = {
  createModel: (items: TRESPONSE_FACTORY_LIST['factories'], showSelectInModel: 'SINGLE' | 'MULTI' | undefined) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        ...(showSelectInModel && {
          select: {
            position: 'START',
            isMulti: showSelectInModel === 'MULTI' || false,
            size: 'DEFAULT',
          },
        }),
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'CLUSTER',
          },
          {
            type: 'TEXT_CELL',
            text: 'FACTORY NAME',
          },
          {
            type: 'TEXT_CELL',
            text: 'OPERATOR COUNT',
          },
          {
            type: 'TEXT_CELL',
            text: '#SEWING LINES',
          },
          {
            type: 'TEXT_CELL',
            text: 'LOCATION',
          },
          {
            type: 'TEXT_CELL',
            text: 'ALLOCATED PRODUCT TYPES',
          },
          {
            type: 'TEXT_CELL',
            text: '',
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.cluster,
            },
            {
              type: 'TEXT_CELL',
              text: item.factory.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.operator_count,
            },
            {
              type: 'TEXT_CELL',
              text: item.sewing_lines,
            },
            {
              type: 'TEXT_CELL',
              text: item.location,
            },
            {
              type: 'TEXT_CELL',
              text: item.product_types?.length ? item.product_types[0] : '--',
              ...(item.product_types?.length > 1 && {
                tag: {
                  tagContent: `+${item.product_types.length - 1}`,
                  tagTooltipContent: item.product_types.slice(1).join(', '),
                  showTooltipEvent: 'hover',
                },
              }),
            },
            {
              type: 'ACTION_LIST_CELL',
              title: 'Actions To be Taken',
              actions: [
                {
                  type: 'OPERATOR_SHIT_SETUP',
                  displayText: 'Operators/Shift setup',
                },
                {
                  type: 'MAP_PRODUCT_EFFICIENCY',
                  displayText: 'Map Product Efficiency',
                },
                {
                  type: 'UOM',
                  displayText: 'Map UoM',
                },
                {
                  type: 'MACHINE_AVAILABILITY_UPLOAD',
                  displayText: 'Machine Availability Upload',
                },
              ],
            },
          ],
        };
      },
    );
  },
};
